import { render, staticRenderFns } from "./login-input.vue?vue&type=template&id=1396da1e&scoped=true"
import script from "./login-input.vue?vue&type=script&lang=js"
export * from "./login-input.vue?vue&type=script&lang=js"
import style0 from "./login-input.vue?vue&type=style&index=0&id=1396da1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396da1e",
  null
  
)

export default component.exports